import { FC, PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { getSpacing, colors } from '@cabonline/ui-shared';
import { Text } from '../../text';
import { StyledRequired } from './styles';
import { Label } from '../../label';

const FormItemWrapper = styled.div`
  margin-bottom: ${getSpacing('s')};
`;

interface FormItemProps extends PropsWithChildren {
  label: string;
  value?: string;
  editMode?: boolean;
  isRequired?: boolean;
  sentenceCased?: boolean;
  testID?: string;
}

export const FormItem: FC<FormItemProps> = ({
  label,
  value,
  editMode = false,
  isRequired = false,
  children,
  sentenceCased = false,
  testID = '',
}) => (
  <FormItemWrapper>
    {editMode ? (
      children
    ) : (
      <>
        <Label label={label} color={colors.gray1}>
          {label}
          {isRequired && <StyledRequired aria-hidden />}
        </Label>
        {value && (
          <Text
            size="m"
            weight="semi"
            sentenceCased={sentenceCased}
            testID={testID}
          >
            {value}
          </Text>
        )}
      </>
    )}
  </FormItemWrapper>
);
